import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const currencySymbolDictionary = createSimpleDictionary(
    [
        { id: 1, name: '€' },
        { id: 2, name: '£' },
        { id: 3, name: '¥' },
        { id: 4, name: 'R$' },
        { id: 5, name: '$' },
        { id: 6, name: 'RM' },
        { id: 7, name: 'hk$' },
    ],
    []
);
